import React, { useContext } from "react";
import { UserContext } from '../../userContext';
import { Login } from '../../components/Login';

export const requireAuth = <P extends object>(Component: React.ComponentType<P>): React.FC<P> => (...props) => {
    const { userData } = useContext(UserContext);
    return userData.spotify.accessToken?.length > 0
        ? <Component {...props as P} />
        : <Login />
}